// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"b9a67675","756":"3bdfec20","973":"a5022bf1"}[chunkId] + ".chunk.css";
};